import { Card, CardContent } from "@/components/ui/card"
import { kpis, customersOverTime } from "../-data/fixtures"
import { ChartContainer, ChartLegend, ChartLegendContent } from "@/components/ui/chart"
import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from "recharts"

export default function NewPatients() {
  return (
    <Card className="rounded-2xl">
      <CardContent className="p-4">
        <div className="flex items-center">
          <div>
            <div className="text-xs text-muted-foreground">New patients</div>
            <div className="text-2xl font-semibold flex items-center gap-2">
              {kpis.newPatients.total}
              <span className="text-green-600 text-xs">↗ {kpis.newPatients.deltaPct}%</span>
            </div>
          </div>
        </div>
        <div className="mt-3">
          <div className="text-sm text-black mb-1">New patients over time</div>
          <ChartContainer config={{ returning: { label: "Returning", color: "#e16a52" }, new: { label: "New", color: "#2aa198" } }} className="w-full h-64 aspect-auto">
            <BarChart data={customersOverTime}>
              <CartesianGrid vertical={false} />
              <XAxis dataKey="month" tickLine={false} axisLine={false} />
              <YAxis hide />
              <Bar dataKey="returning" fill="var(--color-returning)" radius={[4, 4, 0, 0]} />
              <Bar dataKey="new" fill="var(--color-new)" radius={[4, 4, 0, 0]} />
              <ChartLegend content={<ChartLegendContent />} />
            </BarChart>
          </ChartContainer>
        </div>
      </CardContent>
    </Card>
  )
}